import { Person } from '../../../App/store/features/person/IPerson'
import { AppDispatch } from '../../../store'
import { updateAppointmentActivityMoment } from '../../Events/utils/updateAppointmentActivityMoment'
import { resetEventPosition } from '../../store/calendarSlice'
import { fetchAppointment } from '../../store/thunks/fetchAppointment'
import {
  IUpdateAppointmentData,
  updateAppointmentActivity,
} from '../../store/thunks/updateAppointmentActivity'
import { IEvent, IEventCoordinates } from '../../types'
import { isInstanceOfIThunkError } from '../interfaceCheck'

export const appointmentCoordinateUpdate = (
  event: IEvent,
  eventCoordinates: IEventCoordinates,
  filteredPersons: Person[],
  dispatch: AppDispatch,
): void => {
  const appointmentActivity: IUpdateAppointmentData =
    updateAppointmentActivityMoment(eventCoordinates, event, filteredPersons)
  dispatch(
    updateAppointmentActivity({
      data: appointmentActivity,
      appointmentUuid: event.id.split('_')[0],
    }),
  ).then(({ payload }) => {
    if (typeof payload !== 'undefined' && !isInstanceOfIThunkError(payload)) {
      dispatch(resetEventPosition)
      dispatch(
        fetchAppointment({ uuid: payload.appointmentUuid, type: 'update' }),
      )
    }
  })
}
